import {config} from '../config/config';
import Cookies from 'js-cookie';
import store from "@/store";

export async function Fetch(method, url, data = {}) {
    let options = {
        method: method,
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'include',
        referrer: "about:client",
        headers: {
            referer: 'about:client',
            'Content-Type': 'application/json'
        },
    };

    if(method !== 'GET'){
        options['body'] = JSON.stringify(data);
        options['headers']['X-CSRFToken'] = Cookies.get('csrftoken');
    }

    const response = await fetch(config('API_PATH')+url, options);
    let responseJSON = await response.json();
    responseJSON['httpStatus'] = response.status;

    return responseJSON;
}

